import { MainThemeVariants } from 'src/types'
import { COLOR_DICTIONARY } from 'src/constants'

import { useColorThemeSelect } from 'src/features/ColorThemeSelect/useColorThemeSelect'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'src/components/shadcn/select'

export const ColorThemeSelect = (): JSX.Element => {
  const { locale, options, handleSetColorTheme, colorTheme } =
    useColorThemeSelect()

  return (
    <div className="flex flex-col mt-6 max-w-[250px]">
      <div className="flex items-center space-x-7">
        <span className="text-md font-medium w-[72%]">{locale.title}</span>
        <Select
          value={colorTheme}
          onValueChange={(value: MainThemeVariants) =>
            handleSetColorTheme(value as MainThemeVariants)
          }
        >
          <SelectTrigger
            className="w-full"
            customIcon={
              <div>
                <div
                  className="w-4 h-4 rounded-full"
                  style={{ backgroundColor: COLOR_DICTIONARY[colorTheme] }}
                />
              </div>
            }
          >
            <SelectValue placeholder={locale.placeHolder} />
          </SelectTrigger>
          <SelectContent>
            {options.map(({ color, value, title }) => {
              return (
                <SelectItem key={value} value={value} className="relative">
                  <div className="flex justify-between items-center">
                    <div>{title}</div>
                    <div
                      className={`${value === colorTheme ? '' : 'w-4 h-4 rounded-full absolute right-3'}`}
                      style={{ backgroundColor: color }}
                    />
                  </div>
                </SelectItem>
              )
            })}
          </SelectContent>
        </Select>
      </div>
    </div>
  )
}
